import { graphql } from "relay-runtime"

export const dePatientEpisodesOfCareQuery = graphql`
  query dePatientEpisodesOfCareQuery(
    $patientId: ID!
    $appointmentId: ID
    $shouldCreateDraftProgressNote: Boolean!
    $kind: ProgressNoteKind!
    $language: Language!
  ) {
    patientEpisodesOfCare: de_patientEpisodesOfCare(
      patientId: $patientId
      appointmentId: $appointmentId
      shouldCreateDraftProgressNote: $shouldCreateDraftProgressNote
      kind: $kind
      language: $language
      first: null
    ) @connection(key: "RootEpisodesOfCareConnection_patientEpisodesOfCare", filters: ["patientId"]) {
      edges {
        node {
          ...deEpisodeOfCareFragment @relay(mask: false)
          ...deEpisodeOfCareFragment
        }
      }
    }
  }
`
